(function(){
  function initHww(root){
    if(root.dataset.hwwInit) return;
    root.dataset.hwwInit = '1';
    var steps = [].slice.call(root.querySelectorAll('[data-hww-step]'));
    if(!steps.length) return;
    var rail = root.querySelector('[data-hww-rail]');
    var railWrap = root.querySelector('.hww-rail');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DUR = 2500;
    var active = 0, rafId = null, paused = false;

    function railTarget(i){
      if(!railWrap || getComputedStyle(railWrap).display === 'none') return 0;
      return (i / (steps.length - 1)) * 100;
    }
    function stop(){ if(rafId){ cancelAnimationFrame(rafId); rafId = null; } }
    function setActive(i, resume){
      active = i;
      steps.forEach(function(s, idx){
        var on = idx === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
        var bar = s.querySelector('.hww-bar > i');
        if(bar) bar.style.width = '0%';
      });
      if(rail) rail.style.width = railTarget(i) + '%';
      if(!reduce && resume !== false) runStep();
    }
    function runStep(){
      stop();
      if(reduce) return;
      var barI = steps[active].querySelector('.hww-bar > i');
      var startT = null;
      function frame(t){
        if(paused) return;
        if(startT === null) startT = t;
        var p = Math.min((t - startT) / DUR, 1);
        if(barI) barI.style.width = (p * 100) + '%';
        if(p < 1){ rafId = requestAnimationFrame(frame); }
        else { setActive((active + 1) % steps.length); }
      }
      rafId = requestAnimationFrame(frame);
    }
    steps.forEach(function(s){
      var i = parseInt(s.dataset.i, 10);
      s.addEventListener('mouseenter', function(){ paused = true; stop(); setActive(i, false); });
      s.addEventListener('mouseleave', function(){ paused = false; runStep(); });
      s.addEventListener('focus', function(){ paused = true; stop(); setActive(i, false); });
      s.addEventListener('blur', function(){ paused = false; runStep(); });
      s.addEventListener('click', function(){ setActive(i, false); });
      s.addEventListener('keydown', function(e){
        if(e.key === 'ArrowRight'){ e.preventDefault(); steps[(i + 1) % steps.length].focus(); }
        if(e.key === 'ArrowLeft'){ e.preventDefault(); steps[(i + steps.length - 1) % steps.length].focus(); }
      });
    });
    window.addEventListener('resize', function(){ if(rail) rail.style.width = railTarget(active) + '%'; });
    setActive(0);
  }
  function boot(){ [].slice.call(document.querySelectorAll('.how-we-work[data-hww]')).forEach(initHww); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
